import { Menu, Transition } from '@headlessui/react'
import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import React, { Fragment } from 'react'
import { CompatibleLink } from 'src/components/CompatibleLink/CompatibleLink'
interface TopicMenuProps {
  topicsData?: any[]
  topicCurrentIdx: number
  handleSetTopicCurrentIdx: (index: number) => void
  menuClassName?: string
}

/**
 * Primary UI component for user interaction
 */
export const TopicsMenu: React.FC<TopicMenuProps> = ({
  topicsData,
  topicCurrentIdx,
  handleSetTopicCurrentIdx,
  menuClassName,
}) => {
  return (
    <Menu as="div" className="relative inline-block w-24 cursor-pointer">
      {({ open }) => (
        <>
          <Menu.Button
            type="button"
            className={cn(
              'inline-flex justify-center gap-1 items-center w-full text-white font-secondary text-[0.875rem] font-bold tracking-widest',
            )}
          >
            TOPICS
            <IonIcon
              className="text-white mr-0 !important"
              name={open ? 'chevron-up-outline' : 'chevron-down-outline'}
            />
          </Menu.Button>
          {open && (
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                static
                className={cn(
                  'fixed right-[100px] top-[100px] z-[9999] overflow-hidden flex flex-row w-[37.5rem] h-[30rem] rounded-[1.25rem] shadow-lg bg-white',
                  menuClassName,
                )}
              >
                <div className="absolute left-[296px] border-l-[1px] py-4 w-[19rem] h-full overflow-y-auto">
                  <ul className="">
                    {topicsData &&
                      topicsData.map((topic, idx) => {
                        return (
                          <li className="px-3 h-10 w-full" key={idx}>
                            <CompatibleLink
                              href={'/topics/' + topic?.slug}
                              className="font-primary font-semibold text-[0.875rem] text-left px-6 w-full inline-flex items-center h-full text-textdark bg-white rounded-full hover:text-textlight hover:bg-turquoise hover:bg-opacity-10"
                              onMouseOver={() => {
                                handleSetTopicCurrentIdx(idx)
                              }}
                            >
                              <IonIcon
                                className="mr-3"
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                name={topic?.iconName as any}
                              ></IonIcon>
                              {topic?.name}
                            </CompatibleLink>
                          </li>
                        )
                      })}
                  </ul>
                </div>
                <div className="absolute flex flex-col py-4 w-[18.5rem] h-full top-0 left-0 border-l border-mist overflow-y-auto">
                  <p className="mx-6 text-textdark my-2 h-8 items-center border-b-2 border-mist text-[0.875rem] font-primary font-semibold text-left">
                    {topicsData && topicsData[topicCurrentIdx]?.name}
                  </p>
                  {topicsData &&
                    topicsData[topicCurrentIdx]?.subTopics?.map((submenu: any, subidx: number) => {
                      return (
                        <Menu.Item key={subidx}>
                          {({ active }) => (
                            <CompatibleLink
                              href={'/topics/' + topicsData[topicCurrentIdx]?.slug + '/' + submenu?.slug}
                              className={cn(
                                { 'bg-gray-100': active },
                                'block px-6 mx-3 py-2 text-sm text-textdark font-primary font-semibold tracking-normal rounded-full hover:text-textlight hover:bg-turquoise hover:bg-opacity-10',
                              )}
                            >
                              {submenu?.name}
                            </CompatibleLink>
                          )}
                        </Menu.Item>
                      )
                    })}
                  {topicsData && topicsData[topicCurrentIdx] && (
                    <Menu.Item>
                      {({ active }) => (
                        <CompatibleLink
                          href={'/topics/' + topicsData[topicCurrentIdx]?.slug}
                          className={cn(
                            { 'bg-gray-100': active },
                            'block px-6 mx-3 py-2 text-sm text-textdark font-primary font-semibold tracking-normal rounded-full hover:text-textlight hover:bg-turquoise hover:bg-opacity-10',
                          )}
                        >
                          View All
                        </CompatibleLink>
                      )}
                    </Menu.Item>
                  )}
                </div>
              </Menu.Items>
            </Transition>
          )}
        </>
      )}
    </Menu>
  )
}
